import React, {useEffect} from "react"
import Styles from "./leftContent.less"
import {connect, useDispatch} from "react-redux"
import vsImg from "../../../../static/pic/vs.svg"
import {UseCanvasData, UseFileInfo, UseImageList} from "../../../../function/hooks/useDataFromRedux"
import {addScrollEvent} from "../../../../function/base/scrollFunc"
import Layer from "./layer/layer"
import TDAMask from "../../../mask/mask"
import StaticView from "../../../upload/staticView/staticView"
import {ReducerState} from "../../../../reducer/interface/baseInterface"
import {ComparisonStatus} from "../../../../reducer/interface/controlInterface"

interface LeftContentProps {
    comparisonStatus: ComparisonStatus
}

const LeftContent: React.FunctionComponent<LeftContentProps> = (props) => {
    const dispatch = useDispatch()
    const cssTitle = `TDA_LEFT_BOX_CONTENT`
    const [baseInfo, compareInfo] = [UseFileInfo().useDisplayBase(), UseFileInfo().useDisplayCompare()]
    const [baseList, compareList] = [UseImageList().useBase(), UseImageList().useCompare()]
    const [baseCanvasData, compareCanvasData] = [UseCanvasData().useBase(), UseCanvasData().useCompare()]
    useEffect(() => {
        if (props.comparisonStatus.status === "success") {
            addScrollEvent(dispatch)
        }
    }, [props.comparisonStatus.status])
    const renderCanvas = () => {
        return [
            <Layer
                key={"BaseLayer"}
                type={"Base"}
                title={"原文档"}
                fileInfo={baseInfo}
                canvasData={baseCanvasData}
                imgList={baseList}
            />,
            <Layer
                key={"CompareLayer"}
                type={"Compare"}
                title={"比对文档"}
                fileInfo={compareInfo}
                canvasData={compareCanvasData}
                imgList={compareList}
            />,
        ]
    }
    const renderUpload = () => {
        return (
            <div className={Styles[`${cssTitle}_UPLOADBOX`]}>
                <StaticView type={"Base"} />
                <img style={{width: 36, height: 36}} alt={""} src={vsImg} />
                <StaticView type={"Compare"} />
            </div>
        )
    }
    return (
        <div className={Styles[`${cssTitle}`]}>
            <TDAMask />
            {props.comparisonStatus.status === "success" ? renderCanvas() : renderUpload()}
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        comparisonStatus: state.control.comparisonStatus,
    }
})(LeftContent)
